import { SearchBar } from './search';
import { ISearchBar } from './search.interface';

export default SearchBar;
export { SearchBar, ISearchBar };
